import * as Sentry from "@sentry/browser"

export function pushErrorMessage(
  message: string,
  context: Record<string, unknown> = {},
  tags: Record<string, string | number | boolean | null | undefined> = {}
) {
  Sentry.withScope((scope: Sentry.Scope) => {
    scope.setExtras(context)
    scope.setLevel("error")
    scope.setTags(tags)
    Sentry.captureMessage(message)
  })

  console.error(message, context)
}

export function captureErrorMessage(
  message: string,
  context: Record<string, unknown> = {}
) {
  console.error(message, context)
  pushErrorMessage(message, context)
}
